import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { GameCollectionService, SkillGamesConfigService } from "@obg/gaming.external";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction, RouteConfig } from "@obg/ngx.router";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class SkillGamesRouteGuard implements CanActivate {
	constructor(
		private configService: SkillGamesConfigService,
		private collectionService: GameCollectionService,
		private store: Store<CoreState>
	) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		if (!this.configService.getIsSkillGamesRouteEnabled()) {
			this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
			return of(false);
		}

		const collectionSlug = (route.routeConfig as RouteConfig)?.name;

		if (!collectionSlug) {
			this.store.dispatch(RouteAction.navigate(CORE_ROUTE.notFound, undefined, { skipLocationChange: true }));
			return of(false);
		}

		return this.collectionService.isGameCollectionExists(collectionSlug).pipe(
			tap((exists) => {
				if (!exists) {
					this.store.dispatch(
						RouteAction.navigate(CORE_ROUTE.notFound, undefined, { skipLocationChange: true })
					);
				}
			})
		);
	}
}
